"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.concat = concat;
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _iterable = require("../../internal/iterable");

var _marked = _regenerator["default"].mark(concat);

function concat() {
  var _len,
      sources,
      _key,
      _i,
      _sources,
      iterable,
      _args = arguments;

  return _regenerator["default"].wrap(function concat$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          for (_len = _args.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
            sources[_key] = _args[_key];
          }

          _i = 0, _sources = sources;

        case 2:
          if (!(_i < _sources.length)) {
            _context.next = 8;
            break;
          }

          iterable = _sources[_i];
          return _context.delegateYield((0, _iterable.ensureIterable)(iterable), "t0", 5);

        case 5:
          _i++;
          _context.next = 2;
          break;

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

var _default = (0, _iterable.wrapWithMethodIterable)(concat);

exports["default"] = _default;